<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
  class?: HTMLAttributes['class']
}

defineProps<Props>()
</script>

<template>
  <main :class="cn('relative flex flex-col flex-1 overflow-hidden', $props.class)">
    <slot />
  </main>
</template>
